import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
export const trackEvent = (event, getTracker = getUsageTracker, type = 'trackEvent') => {
  let errorMessage = undefined;

  if (typeof event !== 'object') {
    errorMessage = `${type} expects an object, got ${typeof event}`;
  } else if (!Object.prototype.hasOwnProperty.call(event, 'key') || !Object.prototype.hasOwnProperty.call(event, 'properties')) {
    errorMessage = `${type} expects an object with 'key' and 'properties'`;
  }

  if (errorMessage) {
    window.setTimeout(() => {
      throw new Error(errorMessage);
    }, 0);
    return;
  }

  getTracker().track(event.key, event.properties);
};